(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-header"]) return;
  try {
    

if (!customElements.get('service-hours-status')) {
  customElements.define('service-hours-status', class extends HTMLElement {
    connectedCallback() {
      this.updateStatus();
      this.timer = window.setInterval(() => this.updateStatus(), 60000);
    }
    disconnectedCallback() { window.clearInterval(this.timer); }
    updateStatus() {
      try {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/New_York', weekday: 'short', hour: '2-digit', hourCycle: 'h23'
        }).formatToParts(new Date());
        const day = parts.find(part => part.type === 'weekday').value;
        const hour = Number(parts.find(part => part.type === 'hour').value);
        const open = !['Sat', 'Sun'].includes(day) && hour >= 9 && hour < 17;
        this.toggleAttribute('data-open', open);
        this.querySelector('[data-service-label]').textContent = open
          ? 'Online until 5 PM ET'
          : 'Currently offline';
        this.querySelector('[data-service-state]').hidden = false;
      } catch (error) {
        this.querySelector('[data-service-state]').hidden = true;
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
